// Converters for js-joda types

import { JsonConverter, JsonCustomConvert } from 'json2typescript';
import { LocalDate, LocalTime, ZonedDateTime } from '@js-joda/core';

@JsonConverter
export class LocalDateConverter implements JsonCustomConvert<
  LocalDate | undefined
> {
  serialize(date: LocalDate): string {
    return date.toString();
  }

  deserialize(date: string): LocalDate | undefined {
    let res: LocalDate | undefined;
    if (date != null) {
      res = LocalDate.parse(date);
    }
    return res;
  }
}

@JsonConverter
export class LocalTimeConverter implements JsonCustomConvert<
  LocalTime | undefined
> {
  serialize(time: LocalTime): string {
    return time.toString();
  }

  deserialize(time: string): LocalTime | undefined {
    let res: LocalTime | undefined;
    if (time != null) {
      res = LocalTime.parse(time);
    }
    return res;
  }
}

/* Gut says to not use any LocalDateTime because of parsing/what zone problems
@JsonConverter
export class LocalDateTimeConverter implements JsonCustomConvert<LocalDateTime> {
  serialize(date: LocalDateTime): any {
    return date.toString();
  }
  deserialize(date: any): LocalDateTime {
    let res = null;
    if (date != null) {
      res = LocalDateTime.parse(date);
    }
    return res;
  }
}
*/

@JsonConverter
export class ZonedDateTimeConverter implements JsonCustomConvert<
  ZonedDateTime | undefined
> {
  serialize(date: ZonedDateTime): string {
    return date.toString();
  }

  deserialize(date: string | undefined): ZonedDateTime | undefined {
    let res: ZonedDateTime | undefined;
    if (date) {
      res = ZonedDateTime.parse(date);
    }
    return res;
  }
}
